export const getPathQuery = (key) => {
  const queryArr = decodeURIComponent(location.search).split('&')
  const targetKey = `${key}=`
  const targetStr = queryArr.find(item => item.includes(targetKey))
  if (targetStr) {
    return targetStr.split(targetKey)[1]
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/jumpWebsite.js